import { v4 as uuidv4 } from 'uuid';

// Question types enum
export const QUESTION_TYPES = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  SINGLE_CHOICE: 'single_choice',
  MULTIPLE_CHOICE: 'multiple_choice',
  DROPDOWN: 'dropdown',
  RATING: 'rating',
  FILE_UPLOAD: 'file_upload',
};

// Text input subtypes
export const TEXT_INPUT_SUBTYPES = [
  'text',
  'email',
  'password',
  'url',
  'tel',
  'number',
  'range',
  'color',
  'date',
  'datetime-local',
  'month',
  'time',
  'week',
];

// Default question templates
export const getDefaultQuestion = (type) => {
  const baseQuestion = {
    internalId: uuidv4(), // Frontend ID for internal operations
    id: null, // Server ID (populated after save)
    type,
    name:'',
    title: 'New Question',
    description: 'Enter description',
    required: false,
    placeholder: '',
    sequenceNumber: 0,
  };

  switch (type) {
    case QUESTION_TYPES.TEXT:
      return {
        ...baseQuestion,
        title: 'Text Input Question',
        inputType: 'text', // default input subtype
        placeholder: 'Enter your answer...',
        maxLength: null,
        minValue: null,
        maxValue: null,
      };

    case QUESTION_TYPES.TEXTAREA:
      return {
        ...baseQuestion,
        title: 'Long Text Question',
        placeholder: 'Enter your detailed answer...',
        maxLength: null,
        rows: 4,
      };

    case QUESTION_TYPES.SINGLE_CHOICE:
      return {
        ...baseQuestion,
        title: 'Single Choice Question',
        options: [
          { id: uuidv4(), text: 'Option 1', value: 'option_1' },
          { id: uuidv4(), text: 'Option 2', value: 'option_2' },
        ],
      };

    case QUESTION_TYPES.MULTIPLE_CHOICE:
      return {
        ...baseQuestion,
        title: 'Multiple Choice Question',
        options: [
          { id: uuidv4(), text: 'Option 1', value: 'option_1' },
          { id: uuidv4(), text: 'Option 2', value: 'option_2' },
        ],
      };

    case QUESTION_TYPES.DROPDOWN:
      return {
        ...baseQuestion,
        title: 'Dropdown Question',
        placeholder: 'Select an option...',
        options: [
          { id: uuidv4(), text: 'Option 1', value: 'option_1' },
          { id: uuidv4(), text: 'Option 2', value: 'option_2' },
        ],
      };

    case QUESTION_TYPES.RATING:
      return {
        ...baseQuestion,
        title: 'Rating Question',
        minValue: 1,
        maxValue: 5,
        minLabel: 'Poor',
        maxLabel: 'Excellent',
        ratingType: 'stars', // stars, numbers, scale
      };

    case QUESTION_TYPES.FILE_UPLOAD:
      return {
        ...baseQuestion,
        title: 'File Upload Question',
        acceptedFileTypes: ['image/*', 'application/pdf'],
        maxFileSize: 5, // MB
        allowMultiple: false,
      };

    default:
      return baseQuestion;
  }
};
